<template>
  <div class="aside-page">
    <div class="logo-box">
      <router-link to="/index">
        <el-image :src="require('@assets/img/logo.png')" :fit="isCollapse ? 'contain' : 'contain'">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </router-link>
    </div>
    <div class="menu-box">
      <el-menu unique-opened router class="el-menu-vertical-demo" :collapse="isCollapse" :collapse-transition="false"
               :default-active="indexPage" ref="aiMenu" @select="refresh">
        <menu-item v-for="(item, index) in menuList" :key="index" :routeObj="item"></menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuItem from "./components/MenuItem"
  import {getPermissionRoutes} from '@router/permission'
  export default {
    name: "AsidePage",
    inject: ['reload'],
    components: {MenuItem},
    data() {
      return {
        indexPage: "",
        menuList: []
      }
    },
    computed: {
      ...mapGetters([
        'isCollapse'
      ])
    },
    watch: {
      $route(to) {
        this.indexPage = to.path;
      }
    },
    methods: {
      refresh (path) {
        document.body.clientWidth <= 1050 && this.$store.commit("switchCollapse");
        if (path === this.$route.path) {
          // 刷新view
          this.reload();
        }
      }
    },
    created() {
      this.menuList = getPermissionRoutes(this.$store.state.permissions);
      this.indexPage = this.$router.history.current.path || "";
    },
  }
</script>

<style lang="scss">
  .aside-page {
    z-index: 99;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: $aside-width;
    background: linear-gradient(180deg, rgba(239, 246, 255, 0.98) 0%, rgba(219, 234, 254, 0.98) 100%);
    backdrop-filter: blur(20px);
    overflow: hidden;
    transition: $menu-transition;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 15px rgba(59, 130, 246, 0.08);
    animation: fadeIn 0.4s ease-out;
    
    .collapse & {
      width: $aside-width-collapse;
      .menu-box {
        width: $aside-width-collapse + 20;
      }
      .logo-box {
        padding: 0 5px;
        margin: 5px;
        a {
          width: 100%;
          height: 100%;
        }
      }
    }
    .logo-box {
      height: $header-height - 1;
      transition: $menu-transition;
      cursor: pointer;
      background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid rgba(148, 163, 184, 0.1);
      margin: 10px;
      border-radius: 15px;
      
      a {
        display: inline-block;
        width: 90%;
        height: 90%;
        .el-image {
          width: 100%;
          height: 100%;
          .el-image__placeholder {
            background-color: transparent;
          }
          .image-slot {
            height: 100%;
            color: #2563eb;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;
          }
        }
      }
    }
    .menu-box {
      width: $aside-width + 20;
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      transition: all 0.3s ease 0s;
      
      &::-webkit-scrollbar {
        width: 4px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(148, 163, 184, 0.1);
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.3);
        border-radius: 2px;
      }
    }
    .el-menu-vertical-demo {
      width: $aside-width;
      border: none;
      transition: 0s;
      background-color: transparent;
      
      &.el-menu--collapse {
        width: $aside-width-collapse;
        transition: $menu-transition;
        .el-menu-item {
          padding: 0!important;
          text-align: center;
          .el-tooltip {
            padding: 0!important;
            i {
              margin-right: 0;
            }
          }
        }
        .el-submenu {
          .el-submenu__title {
            padding: 0!important;
            text-align: center;
            span {
              height: 0;
              width: 0;
              overflow: hidden;
              visibility: hidden;
              display: inline-block;
            }
            i {
              margin-right: 0;
            }
            .el-submenu__icon-arrow {
              display: none;
            }
          }
        }
      }
      .el-menu-item {
        height: $aside-item-height;
        line-height: $aside-item-height;
        color: #475569;
        background-color: transparent;
        margin: 4px 8px;
        border-radius: 12px;
        transition: all 0.3s ease;
        //animation: fadeInUp 0.3s ease-out backwards;
        min-width: 0;
        
        &:nth-child(1) { animation-delay: 0.05s; }
        &:nth-child(2) { animation-delay: 0.1s; }
        &:nth-child(3) { animation-delay: 0.15s; }
        &:nth-child(4) { animation-delay: 0.2s; }
        &:nth-child(5) { animation-delay: 0.25s; }
        
        i {
          transition: $aside-color-transition;
          color: #475569;
        }
        &:hover {
          background-color: rgba(37, 99, 235, 0.1)!important;
          color: #1d4ed8;
          //transform: translateX(4px);
          
          i {
            color: #1d4ed8;
          }
        }
        &.is-active {
          color: #1d4ed8;
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%);
          box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
          
          &:before {
            content: "";
            position: absolute;
            margin: 4% 0;
            top: 0;
            bottom: 0;
            left: -8px;
            width: 4px;
            background: linear-gradient(180deg, #60a5fa 0%, #3b82f6 100%);
            border-radius: 2px;
            animation: slideIn 0.3s ease-out;
          }
          i {
            color: #1d4ed8;
            animation: iconPulse 1s ease-in-out;
          }
        }
      }
      .el-submenu {
        .el-submenu__title {
          height: $aside-item-height;
          line-height: $aside-item-height;
          color: #475569;
          background-color: transparent;
          margin: 4px 8px;
          border-radius: 12px;
          transition: all 0.3s ease;
          
          i {
            transition: $aside-color-transition;
            color: #475569;
          }
          &:hover {
            background-color: rgba(37, 99, 235, 0.1)!important;
            color: #1d4ed8;
            
            i {
              color: #1d4ed8;
            }
          }
        }
        &.is-active {
          .el-submenu__title {
            color: #1d4ed8;
          }
          i {
            color: #1d4ed8;
          }
        }
        .el-menu {
          background-color: transparent;
          .el-menu-item {
            &:hover {
              background-color: rgba(37, 99, 235, 0.1)!important;
            }
          }
        }
      }
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scaleY(0);
    }
    to {
      opacity: 1;
      transform: scaleY(1);
    }
  }
  
  @keyframes iconPulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
</style>
